import SettingsLayout from '../components/organisms/SettingsLayout';
import { changePasswordHelper } from '../helpers/login.helper';
import { useState } from 'react';

const Settings = () => {
  const [msg, setMsg] = useState('');
  const [msgType, setMsgType] = useState('error');

  const changePasswordHandler = async () => {
    let cp = document.getElementById('current_password').value;
    let p1 = document.getElementById('new_password').value;
    let p2 = document.getElementById('new_password_again').value;
    const result = await changePasswordHelper(cp, p1, p2);
    if (result === 'OK') {
      setMsgType('success');
      setMsg('Your password has been changed.');
      document.getElementById('current_password').value = '';
      document.getElementById('new_password').value = '';
      document.getElementById('new_password_again').value = '';
    } else {
      setMsgType('error');
      setMsg(result);
    }
  };

  return (
    <SettingsLayout
      changePasswordHandler={changePasswordHandler}
      msg={msg}
      msgType={msgType}
    />
  );
};
export default Settings;
